import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { EnumCodigosTwTcAcciones } from '../../../../_importacion/solicitudes/types/enum';
import { CopiaCFExService } from './copiaCFEx.service';
import { CopiaCertificadoExItemViewModel, TcEstadoCopiaCFExEnum } from './copiaCFEx.types';
import { EnumIdsTcEstadoCertificadoFitoEx } from '../../types/enum';

@Component({
    selector: 'app-copiacfex-list',
    templateUrl: './copiaCFEx-list.component.html',
})
export class CopiaCFExListComponent extends ComponentBase implements OnInit {
    @Input() copiasSolicitud: CopiaCertificadoExItemViewModel[];
    @Input() estadoSolicitud: number;
    @Input() idSolicitud: number;
    @Input() estadoCertificadoFitoEx: number;
    // Informa que el formulario padre tiene que recargarse debido al borrado de una copia (las copais se cargan junto con la solicitud en el padre)
    @Output() updateParentForm = new EventEmitter<any>();

    public isCollapsedGrid = false;

    copiaEditable: boolean;
    copiaBorrable: boolean;
    colsCopias: any[];

    constructor(
        private router: Router,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        private confirmationService: ConfirmationService,
        protected exceptionHandler: ExceptionManager,
        private copiaCFService: CopiaCFExService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.isCollapsedGrid = false;

        this.colsCopias = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Image', header: '' },
            { field: 'Codigo', header: 'Código' },
            { field: 'IdTipoSolicitudCopiaExDescripcion', header: 'Tipo' },

            { field: 'IdEstadoCopiaCfEx', header: 'IdEstado', display: 'none' },
            { field: 'NumCopia', header: 'Nº Copia' },
            { field: 'FechaPeticionCopia', header: 'F. Petición' },
            { field: 'FechaInspeccionCopia', header: 'F. Inspección' },
            { field: 'FechaExpedicion', header: 'F. Expedición' },
            { field: 'FechaAnulacion', header: 'F. Anulación' },
        ];
    }

    checkEdit(item: CopiaCertificadoExItemViewModel): boolean {
        return (
            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_COPIA_CF, this.estadoSolicitud).Visible &&
            this.estadoCertificadoFitoEx === EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME &&
            item.IdEstadoCopiaCfEx === TcEstadoCopiaCFExEnum.Nueva
        );
    }

    checkDelete(item: CopiaCertificadoExItemViewModel): boolean {
        return (
            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.NUEVA_BORRAR_COPIA_CF, this.estadoSolicitud).Visible &&
            item.IdEstadoCopiaCfEx === TcEstadoCopiaCFExEnum.Nueva
        );
    }

    onEdit(item: CopiaCertificadoExItemViewModel) {
        this.router.navigate(['/exportacion/solicitud/envioEx/', this.idSolicitud, 'editCopiaCF', item.Id]);
    }

    onDelete(item: CopiaCertificadoExItemViewModel) {
        if (item.IdEstadoCopiaCfEx !== TcEstadoCopiaCFExEnum.Nueva) {
            this.addErrorMessage('No se puede eliminar una solicitud de copia que no esté en estado Nueva');
            return;
        }

        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                this.copiaCFService.deleteCopia(item.Id).subscribe(() => {
                    this.addSuccessMessage('Solicitud de copia eliminada correctamente');

                    this.updateParentForm.emit();
                });
            },
        });
    }
}
